import { render, staticRenderFns } from "./waterUCManage.vue?vue&type=template&id=2fa833bc"
import script from "./waterUCManage.vue?vue&type=script&lang=js"
export * from "./waterUCManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa833bc')) {
      api.createRecord('2fa833bc', component.options)
    } else {
      api.reload('2fa833bc', component.options)
    }
    module.hot.accept("./waterUCManage.vue?vue&type=template&id=2fa833bc", function () {
      api.rerender('2fa833bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/water/waterUCManage.vue"
export default component.exports